import { OptionAbmMenu, OptionMenuApps } from "./../../enums/shared/menu-home.enum";
import { IMenuData } from "./../../interfaces/shared/menu-home.interface";


export const MenuAbmModel: IMenuData[] = [
  {
    title: OptionAbmMenu.GLOBAL,
    disabled: true,
    disabledVip: true,
    disabledRds: true,
    route: "/int/mantenedor/global",
    icon: "",
    iconHover: ""
  },
  {
    title: OptionAbmMenu.FUENTES_INT,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    route: "/int/mantenedor/fuentes/interno",
    icon: "",
    iconHover: ""
  },
  {
    title: OptionAbmMenu.FUENTES_VIP,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    route: "/int/mantenedor/fuentes/vip",
    icon: "",
    iconHover: ""
  },
  {
    title: OptionAbmMenu.SEARCH_INTERNO,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    route: "/int/mantenedor/buscador/interno",
    icon: "",
    iconHover: ""
  },
  {
    title: OptionAbmMenu.SEARCH_VIP,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    route: "/int/mantenedor/buscador/vip",
    icon: "",
    iconHover: "",
  },
  {
    title: OptionAbmMenu.RDS,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    route: "/int/rds/fuentes/interno",
    icon: "",
    iconHover: ""
  },
  {
    title: OptionAbmMenu.PROFILE_REGION,
    disabled: false,
    disabledVip: false,
    disabledRds: false,
    route: "/int/mantenedor/profile-region",
    icon: "",
    iconHover: "",
    serviceView: ["gkl", "kl"]
  },
  {
    title: OptionAbmMenu.PURPOSING,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    route: "/int/mantenedor/purposing",
    icon: "",
    iconHover: ""
  }
];


export const MenuAppsModel: IMenuData[] = [
  {
    title: OptionMenuApps.DM,
    disabled: false,
    disabledVip: false,
    disabledRds: true,
    permissionName: "dm",
    route: "/int/dm/search",
    routeVip: "/vip/dm/search",
    icon: "assets/icons/data_table_edit.svg",
    iconHover: "assets/icons/data_table_edit__blue.svg"
  },
  {
    title: OptionMenuApps.MANTENEDOR,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "abm",
    icon: "assets/icons/setting.svg",
    iconHover: "assets/icons/setting__blue.svg",
    subItems: MenuAbmModel
  },
  {
    title: OptionMenuApps.SEGUIMIENTO_REQID,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "seguimientoReqid",
    route: "/int/seguimiento-reqid",
    icon: "assets/icons/seguimiento.svg",
    iconHover: "assets/icons/seguimiento_blue.svg"
  },
  {
    title: OptionMenuApps.MERGE,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "merge",
    route: "/int/merge",
    icon: "assets/icons/cloud_sync.svg",
    iconHover: "assets/icons/cloud_sync__blue.svg",
    serviceView: ['gkl', 'kl']
  },
  {
    title: OptionMenuApps.BULK,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "bulk",
    route: "/int/bulk",
    icon: "assets/icons/folder_delete.svg",
    iconHover: "assets/icons/folder_delete__blue.svg"
  },
  {
    title: OptionMenuApps.LOGS,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "logs",
    route: "/int/visualizacion-logs",
    routeVip: "/vip/visualizacion-logs",
    icon: "assets/icons/logs.svg",
    iconHover: "assets/icons/logs.svg",
  },
  {
    title: OptionMenuApps.MENU_RDS,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "rds",
    route: "/int/data-maintenance/fuentes-rds",
    routeVip: "/vip/fuentes-rds",
    routeRds: "/rdsportal/data-maintenance/fuentes-rds",
    icon: "assets/icons/rds.svg",
    iconHover: "assets/icons/rds.svg"
  },
  {
    title: OptionMenuApps.DISOCIAR,
    disabled: false,
    disabledVip: true,
    disabledRds: true,
    permissionName: "dissociate",
    route: "/int/dissociate",
    routeVip: "/vip/dissociate",
    icon: "assets/icons/swap_horizontal_circle.svg",
    iconHover: "assets/icons/swap_horizontal_circle.svg",
    countryView: ['ar'],
    serviceView: ['gkl', 'kl']
  },
  {
    title: OptionMenuApps.CONTRIBUTION,
    disabled: false,
    disabledVip: false,
    disabledRds: true,
    permissionName: "contribution",
    route: "/int/contribution",
    routeVip: "/vip/contribution",
    icon: "assets/icons/contribution_icon.svg",
    iconHover: "assets/icons/contribution_icon.svg",
    countryView: ['uy']
  }
];
